import React from 'react';
import { Stack, Box, Typography, TypographyOwnProps, Grid } from '@mui/material';

interface ChecklistProps {
  value: {
    name: string;
    items: string[];
    itemVariant: TypographyOwnProps['variant'] | undefined;
  };
}

const Checklist = ({ value }: ChecklistProps) => {
  const { items, itemVariant } = value;

  if (!items) return null;

  const checkMark = (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
      <circle cx="11.5" cy="11.5" r="11.5" fill="black" />
      <path d="M5.5 11.2778L9.5222 15.25L16.75 7" stroke="white" stroke-width="2.5" />
    </svg>
  );

  // * TODO: Swap this to grid with a max of 4 columns
  // or make # of columns a option in the CMS.

  return (
    <>
      <Grid
        container
        width={'100%'}
        display="flex"
        justifyContent={'space-around'}
        alignContent={'space-around'}
        alignItems={'flex-start'} // Align items to the top
        spacing={1}
      >
        {items.map((item, index) => (
          <Grid item xs={3} sm={3}>
            <Stack>
              <Box 
              display={'flex'} justifyContent={'center'}
               pb={['9px','10px','12px']}
               >
                {checkMark}
              </Box>
              <Box
                key={index}
                display={'flex'}
                flex={1}
                alignContent={'center'}
                justifyContent={'center'}
                alignItems={'center'}
              >
                <Typography variant={itemVariant ?? 'body2'} textAlign={'center'}>
                  {item}
                </Typography>
              </Box>
            </Stack>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default Checklist;
